import React, { FC, PropsWithChildren } from 'react';
import { Texts } from '../types';
import { Box, BoxProps } from '@mui/material';

export interface ErrorProps {
  level?: 'info' | 'warning' | 'error';
  texts?: Texts<'defaultError'>;
  outerBoxProps?: BoxProps;
}

const GLYPH: Record<NonNullable<ErrorProps['level']>, string> = {
  info: '♣',
  warning: '♦',
  error: '♥',
};

/**
 * A single upturned ivory card with the message — used for route errors and
 * in-page failures. Children are rendered as the action row.
 */
export const ErrorLayout: FC<PropsWithChildren<ErrorProps>> = ({
  level = 'error',
  texts = {
    defaultError: 'Something went wrong',
  },
  outerBoxProps,
  children,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100vh"
    gap={2}
    px={2}
    py={3}
    textAlign="center"
    {...outerBoxProps}
  >
    <Box className="bh-mini-fan" aria-hidden="true" sx={{ width: 64 }}>
      <span
        data-red={level !== 'info' ? 'true' : 'false'}
        style={{ transform: 'rotate(-6deg)' }}
      >
        {GLYPH[level]}
      </span>
    </Box>
    <p
      className="bh-h3"
      style={{ maxWidth: 360 }}
      role={level === 'error' ? 'alert' : 'status'}
    >
      {texts.defaultError}
    </p>
    {children && (
      <div className="bh-row" style={{ justifyContent: 'center' }}>
        {children}
      </div>
    )}
  </Box>
);
